module.exports = __webpack_public_path__ + "img/ChartFunktionen.d5196797.png";